import {
  ajaxUniGetAsync,
  ajaxUniPostUsingCaptcha,
  ajaxPlatebniBranaAkaPost,
} from './shared/ajaxutils';
import {
  LoadOrderDetailAsync,
  LoadCourseInstancesForLastLoadedDetailAsync,
  ShowMyCartSummaryAsync,
  MarkCoursesOccupancyAsync,
  MarkMyCoursesAsync,
} from './aka.js';
import { getUrlParameter } from './shared/utils';
import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';

declare const window: Window;
const jQuery = window.jQuery;

export async function mainobjednavka() {
  const id = getUrlParameter('id').toString();
  console.log('load order ' + id);
  //await LoadOrderDetailAsync(id);
  //await LoadCourseInstancesForLastLoadedDetailAsync();
  //await MarkCoursesOccupancyAsync();
  //await MarkMyCoursesAsync();
  await LoadOrderUserInfoByIdAsync(id);
  await ShowMyCartSummaryAsync();
}

export function LoadOrderUserInfoByIdAsync(id: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = { orderid: id };
    const successFunc = (result: string) => {
      console.log('load OrderUserInfo returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      // alert('fillorderuserinfo' + JSON.stringify(json)); //fillorderuserinfo
      // if (result.trim() !== '{}') {
      fillValuesJson(json);
      //} else {
      //jQuery('#userinfofilled').html(
      //  '<b>Když se přihlásíte vpravo nahoře, tak budou údaje předvyplněny</b>',
      //);
      //}
      resolve(true);
    };
    ajaxUniGetAsync('LoadOrderUserInfoById', data, successFunc);
  });
}

function setValue(name: string, value: string) {
  jQuery('#form' + name).val(value);
}

export function fillValuesJson(json: any) {
  setValue('company', json.company);
  setValue('name', json.name);
  setValue('surname', json.surname);
  setValue('email', json.email);
  setValue('phone', json.phone);
  setValue('street', json.street);
  setValue('city', json.city);
  setValue('psc', json.psc);
  setValue('country', json.country);
  setValue('ic', json.ic);
  setValue('dic', json.dic);
  setValue('comment', json.comment);
  // jQuery("textarea[name='poznamka']").text = json.comment;
  // validate();
}
